<h2 mat-dialog-title>Information</h2>
<button class="btn-close btn-icon" mat-dialog-close title="Luk dialog">
  <mat-icon class="material-icons">close</mat-icon>
</button>

<mat-dialog-content>
  <strong>Adgangskrav</strong>
  <p>{{ data.comment }}</p>
</mat-dialog-content>
